import React from "react";
import { Button } from "../../../../components/Buttons";
import { STRINGS } from "../strings";
import CustomModal from "../../../../components/Modals/CustomModal";
import TypographyInline from "../../../../components/Typography/TypographyInline";
import { GREY } from "../../../../utils/constants/colors";
import { fontWeight } from "../../../../utils/constants/UI";
import classes from "./DealsComp.module.css";

const DealDeleteModal = ({
  deleteButtonLoading = false,
  deleteAPIHandler = () => {},
  open = false,
  close = () => {},
}) => {
  const deleteModalHeader = {
    heading: {
      id: STRINGS.DELETE_MODAL_COMMENT,
      label: STRINGS.DELETE_DEAL_HEADER_TILE,
    },
  };

  const deleteModalRightFooter = (
    <div className={classes.modalFooterRightData}>
      <Button
        label={STRINGS.CANCEL}
        variant={"ghost"}
        size={"sm36"}
        onClick={close}
      />

      <Button
        label={STRINGS.DELETE}
        variant={"primary"}
        size={"sm36"}
        onClick={deleteAPIHandler}
        isLoading={deleteButtonLoading}
      />
    </div>
  );
  const deleteModalLeftFooter = <div></div>;

  return (
    <CustomModal
      variant={"error"}
      close={close}
      open={open}
      header={deleteModalHeader}
      footer={{
        left: deleteModalLeftFooter,
        right: deleteModalRightFooter,
      }}
    >
      <div className={classes.modalBody}>
        <TypographyInline
          size={"sm"}
          color={GREY.SECONDARY}
          fontWeight={fontWeight.REGULAR}
          label={STRINGS.ARE_YOU_SURE_DELETE}
        />
      </div>
    </CustomModal>
  );
};

export default DealDeleteModal;
